import React, { useState, useMemo } from "react";
import { Container } from "reactstrap";
import { Link } from "react-router-dom";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  Edit02Icon,
  AddSquareIcon,
  DeleteIcon,
  ViewIcon,
} from "@hugeicons/core-free-icons";
import { useGetArrivalsQuery, useImportArrivalMutation } from "../../services/arrivals";
import { Dropdown } from "antd";
import { FileExcelIcon } from "../../assets/icons";
import { ImportCampaignModal } from "../Campaigns/ImportCampaignModal";
import { useTranslation } from "react-i18next";
import BtnAsLink from "../../Component/BtnAsLink";
import ConfirmModal from "../../CommonElements/ConfirmModal";
import { Trans } from "react-i18next";
import { TableC } from "../../CommonElements/TableC";
import { useLocalizedText } from "../../utils/hooks/useLocalizedText";
import { useDebouncedSearch } from "../../utils/hooks/useDebouncedSearch";
import { visitDateOptions } from "../Campaigns/data";
import { SelectCountry } from "../../Component/Form/SelectCountry/SelectCountry";
import { useDeleteInitialCampaignMutation } from "@/services/campaigns";
import { PieChartIcon } from "@hugeicons/core-free-icons/index";
import { LabelValue } from "@/Component/Value";
import { useSystem } from "@/utils/hooks/useLocation";
import { permissions } from "@/utils/constants";
import { Can } from "@/CommonElements/PermissionGate";
import usePermissions from "@/utils/hooks/usePermissions";
import { SelectCachedOptions } from "@/Component/SelectCachedOptions";

export const UpComming = () => {
  const { t } = useTranslation();
  const {
    hasAnyPermission
  } = usePermissions();
  const { getLocalizedNumber } = useLocalizedText();
  const [showImportModal, setShowImportModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const { currentSystem, port, from_id } = useSystem()
  const isMadina = currentSystem === "madina";
  const canViewCampaign = hasAnyPermission([isMadina ? permissions.view_campaigns_for_madina : permissions.view_campaigns]);
  const canUpdateCampaign = hasAnyPermission([isMadina ? permissions.update_campaigns_for_madina : permissions.update_campaigns]);
  const canDeleteCampaign = hasAnyPermission([isMadina ? permissions.delete_campaigns_for_madina : permissions.delete_campaigns]);
  const canViewCampaignDetails = hasAnyPermission([isMadina ? permissions.view_campaign_details_for_madina : permissions.view_campaign_details]);
  const canCreateCampaign = hasAnyPermission([isMadina ? permissions.create_campaigns_for_madina : permissions.create_campaigns]);
  const canImportCampaign = !isMadina && hasAnyPermission([permissions.import_campaigns]);
  const [filters, setFilters] = useState({
    direction_id: from_id,
  });

  const [deleteModalState, setDeleteModalState] = useState({
    isOpen: false,
    arrivalId: null,
    entry_port: null,
  });
  const importMutation = useImportArrivalMutation();
  const { getLocalizedText } = useLocalizedText();

  const { searchValue, debouncedValue, setSearchValue } = useDebouncedSearch(
    "",
    500
  );

  const {
    data: arrivalsRes,
    isLoading,
  } = useGetArrivalsQuery({
    search: debouncedValue,
    page: currentPage,
    ...filters,
  });

  const arrivals = arrivalsRes?.data?.data || [];
  const meta = arrivalsRes?.data?.meta;
  const loading = isLoading;

  // Delete mutation
  const { mutate: deleteArrival, isPending: isDeleting } =
    useDeleteInitialCampaignMutation();

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleFilterApply = (filterData) => {
    setFilters(filterData);
    setCurrentPage(1);
  };

  const handleFilterReset = () => {
    setFilters({
      direction_id: from_id,
    });
    setCurrentPage(1);
  };

  // Handle delete modal
  const handleDeleteClick = (arrivalId) => {
    setDeleteModalState({
      isOpen: true,
      arrivalId,
      entry_port: port,
    });
  };

  const handleDeleteCancel = () => {
    setDeleteModalState({ isOpen: false, arrivalId: null, entry_port: null });
  };

  const handleDeleteConfirm = () => {
    if (deleteModalState.arrivalId) {
      deleteArrival(
        {
          id: deleteModalState.arrivalId,
          entry_port: deleteModalState.entry_port,
        },
        {
          onSuccess: () => {
            setDeleteModalState({
              isOpen: false,
              arrivalId: null,
              entry_port: null,
            });
          },
          onError: () => {
            setDeleteModalState({
              isOpen: false,
              arrivalId: null,
              entry_port: null,
            });
          },
        }
      );
    }
  };
  // Define columns configuration with render functions
  const columns = useMemo(
    () =>
      [
        {
          name: t("UPCOMING_COL_SERIAL"), key: "campaign_number",
          render: (value, rowData) =>
            value ? (
              <Link className="fw-bold" to={`${rowData.id}/${port}/view`}>
                {getLocalizedNumber(String(value))}
              </Link>
            ) : (
              "-"
            )
        },
        {
          name: t("UPCOMING_COL_MANAGER"), key: "campaign_name",
        },
        {
          name: t("UPCOMING_COL_NATIONALITY"),
          key: "nationality_id",
          render: (value) => <SelectCountry.Display value={value} />,

        },
        {
          name: t("UPCOMING_COL_COUNTRY"), key: "country_id",
          render: (value) => <SelectCountry.Display value={value} />,
        },
        {
          name: t("UPCOMING_COL_CITY"), key: "state_id",
          render: (value) => <SelectCachedOptions.Display optionKey="states" value={value} campareBy="id" render={(state) => <LabelValue.Value value={state?.name} />} />,
        },
        {
          name: t("UPCOMING_COL_PILGRIMS"),
          key: "total_capacity",

        },
        {
          name: t("MAKKAH_SERVICE_CENTER_ID"),
          key: "service_center",
          render: (value) => <LabelValue.Value value={getLocalizedText(value?.name_ar, value?.name_en)} />,

        },
        {
          name: t("MADINA_SERVICE_CENTER_ID"),
          key: "madina_service_center",
          render: (value) => <LabelValue.Value value={getLocalizedText(value?.name_ar, value?.name_en)} />,
        },
        {
          name: t("UPCOMING_COL_VISIT"), key: "visit",
          render: (value) => t(value?.toUpperCase())
        },
        {
          name: t("UPCOMING_COL_FLIGHTS_COUNT"),
          key: "segments_count",
        },
        {
          name: t("UPCOMING_COL_PORT"),
          key: "entry_port",

          visible: false,
        },
        {
          name: t("UPCOMING_COL_FIRST_FLIGHT"),
          key: "first_flight_date",

          visible: false,
        },
        {
          name: t("UPCOMING_COL_LAST_FLIGHT"),
          key: "last_flight_date",

          visible: false,
        },
        {
          name: t("UPCOMING_COL_MOBILE"),
          key: "mobile",

          visible: false,
        },
        (canViewCampaign || canUpdateCampaign || canDeleteCampaign || canViewCampaignDetails) && {
          name: t("UPCOMING_COL_ACTIONS"),
          key: "actions",
          filterable: false,
        },
      ].filter(Boolean),
    [t, port, getLocalizedNumber, getLocalizedText, canDeleteCampaign, canUpdateCampaign, canViewCampaign, canViewCampaignDetails]
  );

  // Define actions function
  const getActions = (rowData) => {
    const entry_port = port;
    const editUrl = `${rowData.id}/${entry_port}/edit`;
    const viewUrl = `${rowData.id}/${entry_port}/view`;
    const actions = [];
    if (canViewCampaign) {
      actions.push({
        label: (
          <Link to={viewUrl} className="d-flex align-items-center gap-2">
            <HugeiconsIcon size={18} icon={ViewIcon} />
            <span>{t("VIEW")}</span>
          </Link>
        ),
        key: "view",
      });
    }
    if (canUpdateCampaign) {
      actions.push({
        label: (
          <Link
            to={`/app/${currentSystem}/basic-data/campaigns/${rowData.id}/edit`}
            className="d-flex align-items-center gap-2"
          >
            <HugeiconsIcon size={18} icon={Edit02Icon} />
            <span>{t("EDIT_CAMPAING")}</span>
          </Link>
        ),
        key: "edit-initial-campaign",
      });
    }
    if (canViewCampaign || canViewCampaignDetails) {
      actions.push({
        label: (
          <Link to={editUrl} className="d-flex align-items-center gap-2">
            <HugeiconsIcon size={18} icon={PieChartIcon} />
            <span>{t("MANAGE_SEGMENTS")}</span>
          </Link>
        ),
        key: "add-details",
      });
    }

    const deleteAction = canDeleteCampaign && {
        label: (
          <div className="d-flex align-items-center gap-2">
            <HugeiconsIcon size={18} icon={DeleteIcon} />
            <span>{t("DELETE")}</span>
          </div>
        ),
        key: "delete",
        onClick: () => handleDeleteClick(rowData.id, rowData.entry_port),
        danger: true,
      };

    if (deleteAction) {
      if (actions.length > 0) {
        actions.push({ type: "divider" });
      }
      actions.push(deleteAction);
    }
    return actions;
  };

  // Add button dropdown
  const addButton = (
    <Can anyOf={[isMadina ? permissions.create_campaigns_for_madina : permissions.create_campaigns, !isMadina ? permissions.import_campaigns : null].filter(Boolean)}>
      <Dropdown
        trigger={["click"]}
        disabled={loading}
        menu={{
          items: [
            canCreateCampaign && {
              label: (
                <Link to={`/app/${currentSystem}/basic-data/campaigns/create`}>
                  {t("ADD_MANUAL")}
                </Link>
              ),
              icon: <HugeiconsIcon icon={AddSquareIcon} />,
              key: "add",
            },
            canImportCampaign && {
              label: t("ADD_FROM_EXCEL"),
              key: "add-from-excel",
              icon: <FileExcelIcon />,
              onClick: () => setShowImportModal(true),
            },
          ].filter(Boolean),
        }}
      >
        <span>
          <BtnAsLink
            className="btn-primary"
            icon={<HugeiconsIcon icon={AddSquareIcon} />}
            disabled={loading}
          >
            {t("ADD")}
          </BtnAsLink>
        </span>
      </Dropdown>
    </Can>
  );

  const filterFields = [
    {
      name: "date",
      label: t("DATE"),
      type: "date",
    },
    {
      name: "campaign_number",
      label: t("CAMPAIGN_NUMBER"),
      type: "input",
    },
    {
      name: "nationality_id",
      label: t("UPCOMING_COL_NATIONALITY"),
      type: "select",
      optionKey: "nationalities",
      options: (n) => ({
        value: n.id,
        label: <SelectCountry.Display value={n.id} />,
      }),
    },
    {
      name: "country_id",
      label: t("UPCOMING_COL_COUNTRY"),
      type: "select",
      optionKey: "nationalities",
      options: (c) => ({
        value: c.id,
        label: <SelectCountry.Display value={c.id} />,
      }),
    },
    {
      name: "state_id",
      label: t("UPCOMING_COL_CITY"),
      type: "select",
      optionKey: "states",
      options: (s) => ({
        value: s.id,
        label: [s.code, s.name].join(" - "),
      }),
    },
    {
      name: "service_center_id",
      label: t("UPCOMING_COL_MAKTAB"),
      type: "select",
      optionKey: "service_centers",
      options: (sc) => ({
        value: sc.id,
        label: sc.name,
      }),
    },
    {
      name: "makkah_contract_id",
      label: t("MAKKAH_CONTRACTS"),
      type: "select",
      optionKey: "contracts",
      filter: (c) => c.city_id === "603",
      options: (c) => ({
        value: c.id,
        label: [c.id, c.house_commercial_name_ar].join(" - "),
      }),
    },
    {
      name: "madinah_contract_id",
      label: t("MADINAH_CONTRACTS"),
      type: "select",
      optionKey: "contracts",
      filter: (c) => c.city_id === "605",
      options: (c) => ({
        value: c.id,
        label: [c.id, c.house_commercial_name_ar].join(" - "),
      }),
    },
    {
      name: "visit",
      label: t("UPCOMING_COL_VISIT"),
      type: "select",
      options: visitDateOptions(t),
    },
    {
      name: "direction_id",
      label: t("DIRECTION"),
      type: "select",
      optionKey: "directions",
      options: (d) => ({
        value: d.id,
        label: d.name,
      }),
      filter: (d) => d.id === 1 || d.id === 2,
    },
  ];

  return (
    <Container fluid>
      <TableC
        data={arrivals}
        columns={columns}
        loading={loading}
        searchValue={searchValue}
        onSearchChange={handleSearchChange}
        searchPlaceholder={t("SEARCH_HERE")}
        pagination={
          meta
            ? {
              current: currentPage,
              total: meta.total,
              pageSize: meta.per_page,
              onChange: handlePageChange,
            }
            : undefined
        }
        actions={getActions}
        renderActions={addButton}
        // filterModal={CustomFilterModal}
        filterFields={filterFields}
        filters={filters}
        onFilterApply={handleFilterApply}
        onFilterReset={handleFilterReset}
        emptyStateTitle={
          debouncedValue ? t("NO_SEARCH_RESULTS") : t("NO_UPCOMMING")
        }
        emptyStateDescription={
          debouncedValue
            ? t("NO_SEARCH_RESULTS_DESCRIPTION")
            : t("NO_UPCOMMING_DESCRIPTION")
        }
        headerKey="campaign_number"
        headerRender={(data) => <LabelValue label={t("CAMPAIGN_NUMBER") + ": "} value={data.campaign_number} />}
        minVisibleColumns={2}
        skeletonCount={3}
      />

      {/* Delete Confirmation Modal */}
      <ConfirmModal
        isOpen={deleteModalState.isOpen}
        onToggle={handleDeleteCancel}
        onConfirm={handleDeleteConfirm}
        title={t("CONFIRM")}
        message={
          <Trans
            i18nKey="CONFIRM_DELETE_ARRIVAL"
            components={{
              danger: <span className="text-danger" />,
            }}
          />
        }
        dangerText={t("DELETE")}
        confirmText={t("DELETE")}
        cancelText={t("CANCEL")}
        isLoading={isDeleting}
        defaultLoadingText={t("DELETING")}
        loadingText={t("DELETING")}
        confirmVariant="danger"
        confirmIcon={DeleteIcon}
      />

      {/* Import Campaign Modal */}
      <ImportCampaignModal
        isOpen={showImportModal}
        toggle={() => setShowImportModal(false)}
        modalTitle={t("IMPORT_ARRIVALS")}
        importMutation={importMutation}
      />
    </Container>
  );
};

export default UpComming;
